import React, { useState, useEffect, useRef } from "react";

import ReportsGemstoneService from "../../../services/reports-Gemstone.service";
import { BlobToDownloadFile } from "../../../helper/commanFunction";
import { Pie, getElementAtEvent } from "react-chartjs-2";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ReportJewelryReportService from "../../../services/reports-Jewelry-service";
import moment from "moment";
import DefaultImage from "../../../assets/images/icons/sampleimage.jpg";
import { Button, DatePicker, Modal, Select, Spin, Table, Tooltip, message } from "antd";


const { RangePicker } = DatePicker;
const initialEventState = {
  dealerID: "",
  forDealer: "",
  fromDate: moment().subtract(30, "days"),
  toDate: moment(),
  SelectedGemstoneValue: "All",
  price: "",
  price1: "",
  price2: "",
};

const GemstonePriceBasedWishListReports = () => {
  const { t } = useTranslation();
  const JewelPriceChartRef = useRef();
  const { Option } = Select;

  const [dealerId, setDealerId] = useState();
  const loginDetials = useSelector((state) => state.loginReducer);
  const [selectedData, setSelectedData] = useState(initialEventState);
  const [isApplyFilter, setIsApplyFilter] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [showTableLoader, setShowTableLoader] = useState(false);
  const [JewelryPriceTableList, setJewelryPriceTableList] = useState([]);
  const [visible, setVisible] = useState(false);
  const [defaultVisible, setDefaultVisible] = useState(false);
  const [showChart, setShowChart] = useState(false);
  const [totalValueForPercentage, setTotalValueForPercentage] = useState(0);
  const [priceRange, setPriceRange] = useState([]);
  const [topPriceTotal, setPriceTotal] = useState([]);
  const [TooltipPercentage, setTooltipPercentage] = useState("");
  const [key, setKey] = useState(true);
  const [sortColumnName, setSortColumnName] = useState("AK.Date");
  const [sortType, setSortType] = useState("asc");
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [TotalGemstoneClicks, setTotalGemstoneClicks] = useState(0);
  const [downloadPDFDataloading, setDownloadPDFDataloading] = useState(false);

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          handleGetForDealer(loginDetials.loginDetials.responseData.dealerId);
        }
      }
    }
    handleGetForDealer(loginDetials.loginDetials.responseData.dealerId);
  }, []);

  useEffect(() => {
    if (selectedData.price1)
      handleGetTableChartData(dealerId, selectedData.forDealer);
  }, [selectedData]);

  const handleGetForDealer = (id) => {
    try {
      const initialEventState = {
        dealerID: id,
      };
      setShowLoader(true);
      ReportJewelryReportService.GetForDealer(initialEventState).then(
        (response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;

          // Calculate forDealer based on dealerMemberTypeName
          let forDealer;
          if (
            loginDetials.loginDetials.responseData.dealerMemberTypeName ===
              "VendorGemstone" ||
            loginDetials.loginDetials.responseData.dealerMemberTypeName === "Vendor"
          ) {
            forDealer = 1;
          } else if (
            loginDetials.loginDetials.responseData.dealerMemberTypeName ===
              "Retailer" ||
            loginDetials.loginDetials.responseData.dealerMemberTypeName === "Combined"
          ) {
            forDealer = 2;
          } else {
            forDealer = 3;
          }

          if (message === "Success") {
            setSelectedData((prevState) => ({
              ...prevState,
              forDealer: forDealer,
            }));
            handleGetPriceColumnData(id, forDealer);
            handleGetTableChartData(
              id,
              forDealer,
              pageNo,
              pageSize,
              sortColumnName,
              sortType,
              "Empty_Price"
            );
          }
        }
      );
    } catch (error) {
      console.log(error);
    }
  };

  const handleGetPriceColumnData = (DealerId, forDealerId) => {
    try {
      if (
        loginDetials.loginDetials.responseData.dealerMemberTypeName ===
        "VendorGemstone"
      ) {
        forDealerId = 1;
      }
      const initialEventState = {
        dealerID: DealerId.toString(),
        forDealer: forDealerId.toString(),
        fromDate: selectedData.fromDate
          ? moment(selectedData.fromDate).format("YYYY-MM-DD")
          : "2016-03-07",
        toDate: selectedData.toDate
          ? moment(selectedData.toDate).format("YYYY-MM-DD")
          : "2023-04-06",
        selectedGemstoneValue: selectedData.SelectedGemstoneValue
          ? selectedData.SelectedGemstoneValue.toString()
          : "All",
        addToType: "AddToWishlist",
      };
      setShowLoader(true);
      ReportsGemstoneService.AddToCartOrWishlistChartColunmData(
        initialEventState
      ).then((response) => {
        let message = response.data.message;
        let responseData = response.data.responseData.PriceBasedData;

        if (message === "Success") {
          let priceRange = [];
          let total = [];
          let showResp = responseData.every((element) => {
            return element.TOTAL == "0";
          });
          setShowChart(showResp);
          for (let i of responseData) {
            if (i.TOTAL !== 0) {
              priceRange.push(i.Range);
              total.push(i.TOTAL);
            }
          }

          var JewelVendorYAxisList = responseData.map((item) => {
            return parseInt(item.TOTAL);
          });
          var totalValueForPercentage = JewelVendorYAxisList.reduce(
            (a, b) => a + b,
            0
          );
          setTotalGemstoneClicks(
            response.data.responseData.TotalGemstoneClicks[0].TotalClickCnt
          );
          setTotalValueForPercentage(totalValueForPercentage);
          setPriceTotal(total);
          setPriceRange(priceRange);
          setShowLoader(false);
          setKey(!key);
        } else {
          setShowLoader(false);
        }
      });
    } catch (error) {
      console.log(error);
      setShowLoader(false);
    }
  };
  const [totalCount, setTotalCount] = useState(0);
  // For Chart Data
  const handleGetTableChartData = (
    DealerId,
    forDealerId,
    pageNumber,
    pageSiz,
    sortColumnName,
    sortOrder,
    priceValueEmpty
  ) => {
    try {
      if (
        loginDetials.loginDetials.responseData.dealerMemberTypeName ===
        "VendorGemstone"
      ) {
        forDealerId = 1;
      }
      let inputData = {
        dealerID: DealerId.toString(),
        forDealer: forDealerId ? forDealerId.toString() : "",
        fromDate: selectedData.fromDate
          ? moment(selectedData.fromDate).format("YYYY-MM-DD")
          : "2016-03-07",
        toDate: selectedData.toDate
          ? moment(selectedData.toDate).format("YYYY-MM-DD")
          : "2023-04-06",
        clarity: "",
        GemType: "",
        shape: "",
        color: "",
        size: "",
        certificate: "",
        selectedGemstoneValue: selectedData.SelectedGemstoneValue
          ? selectedData.SelectedGemstoneValue.toString()
          : "All",
        pageNumber: pageNumber ? pageNumber : pageNo,
        pageSize: pageSiz ? pageSiz : pageSize,
        sortOrderCol: sortColumnName ? sortColumnName : sortColumnName,
        sortOrderType: sortOrder ? sortOrder : sortType,
        addToType: "AddToWishlist",
        price: priceValueEmpty ? "" : selectedData.price,
        price1: priceValueEmpty ? "" : selectedData.price1.trim().toString(),
        price2: priceValueEmpty ? "" : selectedData.price2.trim().toString(),
        vendorIds: "",
      };

      setShowTableLoader(true);
      ReportsGemstoneService.AddToCartOrWishlistReportForTableChart(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData.tableChartList;
          if (message === "Success") {
            setTotalCount(response?.data?.responseData?.totalCount || 0);
            setJewelryPriceTableList(responseData);
            setShowTableLoader(false);
          } else {
            setTotalCount(0);
            setJewelryPriceTableList([]);
            setShowTableLoader(false);
          }
        })
        .catch((error) => {
          setTotalCount(0);
          setShowTableLoader(false);
          console.log(error);
        });
    } catch (error) {
      setTotalCount(0);
      console.log(error);
      setShowTableLoader(false);
    }
  };

  // Backend "Download PDF" (chart + Ranked Breakdown), same design as the
  // Gemstone Type report's Download PDF.
  const handleExportToPDF = () => {
    let forDealerId = selectedData.forDealer;
    if (
      loginDetials.loginDetials.responseData.dealerMemberTypeName ===
      "VendorGemstone"
    ) {
      forDealerId = 1;
    }
    const fromDate = moment(selectedData.fromDate).format("YYYY-MM-DD");
    const toDate = moment(selectedData.toDate).format("YYYY-MM-DD");
    let inputData = {
      dealerID: dealerId ? dealerId.toString() : "",
      forDealer: forDealerId ? forDealerId.toString() : "",
      fromDate: fromDate,
      toDate: toDate,
      selectedGemstoneValue: selectedData.SelectedGemstoneValue ? selectedData.SelectedGemstoneValue.toString() : "All",
      addToType: "AddToWishlist",
      reportName: "Price",
    };
    setDownloadPDFDataloading(true);
    ReportsGemstoneService.ExportAddToCartOrWishlistPdf(inputData)
      .then((response) => {
        setDownloadPDFDataloading(false);
        const fileName = `GemstonePrice_WishList_${fromDate}_${toDate}.pdf`;
        BlobToDownloadFile(response.data, fileName, "pdf");
      })
      .catch(() => {
        setDownloadPDFDataloading(false);
        message.error(t("Failed to generate PDF. Please try again."));
      });
  };

  const handleApplyFilter = () => {
    handleGetForDealer(dealerId);

    setIsApplyFilter(!isApplyFilter);
  };

  const onDateChange = (dates, dateStrings) => {
    if (dates) {
      setSelectedData((prevState) => ({
        ...prevState,
        fromDate: moment.utc(dates[0]).toISOString(),
        toDate: moment.utc(dates[1]).toISOString(),
      }));
    }
  };

  const handleOnChange = (e, isSelect, name) => {
    setSelectedData({
      ...selectedData,
      [name]: e,
    });
  };

  const handleTableASCDES = (pagination, filters, sorter) => {
    var tableBody = document.querySelector(".pendjewelreq__tbl .ant-table-body"); if (tableBody) tableBody.scrollTop = 0;
    var type = "";
    var column = "";
    //sorting
    if (sorter.order == "descend") {
      type = "DESC";
      column = sorter.field;
      setSortType(type);
      setSortColumnName(column);
    } else if (sorter.order == "ascend") {
      type = "ASC";
      column = sorter.field;
      setSortType(type);
      setSortColumnName(column);
    } else {
      type = "DESC";
      column = "dealerId";
      setSortColumnName(column);
      setSortType(type);
    }

    setPageNo(pagination.current);
    setPageSize(pagination.pageSize);

    handleGetTableChartData(
      dealerId,
      selectedData.forDealer,
      pagination.current,
      pagination.pageSize,
      column,
      type
    );
  };

  return (
    <React.Fragment>
      <div className="pendjewelreq__section form__fields">
        <div className="row magento__mapping">
          <div className="col-md-12">
            <div className="edr-pagehead-row">
              <div className="edr-pagehead">
                <h1 className="edr-pagehead-title">{t("Gemstone Price Based Wish List Report")}</h1>
                <div className="edr-pagehead-sub">
                  {moment(selectedData.fromDate).format("MMM D, YYYY")}
                  {" – "}
                  {moment(selectedData.toDate).format("MMM D, YYYY")}
                </div>
              </div>
              <div className="edr-pagehead-actions">
                <Button className="ghost-btn" onClick={handleExportToPDF} loading={downloadPDFDataloading}>
                  <i className="fa fa-download"></i> {t("Download PDF")}
                </Button>
                <button className="primary-btn" onClick={handleApplyFilter}>
                  {t("Apply Filter")}
                </button>
              </div>
            </div>
          </div>

          <div className="col-md-12">
            <div className="row edr-filters">
              <div className="col-md-3">
                <div className="input__block datepicker__block">
                  <label> {t("Date Range")} </label>
                  <RangePicker
                    className="date-range-input"
                    ranges={{
                      Today: [moment(), moment()],
                      Yesterday: [
                        moment().subtract(1, "days"),
                        moment().subtract(1, "days"),
                      ],
                      "Last 7 Days": [moment().subtract(7, "days"), moment()],
                      "Last 30 Days": [moment().subtract(30, "days"), moment()],
                      "This Month": [
                        moment().startOf("month"),
                        moment().endOf("month"),
                      ],
                      "Last Month": [
                        moment().subtract(1, "month").startOf("month"),
                        moment().subtract(1, "months").endOf("month"),
                      ],
                      "Last 90 Days": [moment().subtract(90, "days"), moment()],
                      "Year To Date": [moment().startOf("year"), moment()],
                    }}
                    format={"MM-DD-YYYY"}
                    onChange={onDateChange}
                    defaultValue={[moment().subtract(30, "days"), moment()]}
                    defaultPickerValue={[moment().subtract(30, "days"), moment()]}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="input__block">
                  <label> {t("Select Gemstone")} </label>
                  <Select
                    className="border__grey"
                    placeholder={t("All")}
                    showSearch
                    name="SelectedGemstoneValue"
                    optionFilterProp="children"
                    value={
                      selectedData.SelectedGemstoneValue
                        ? selectedData.SelectedGemstoneValue
                        : null
                    }
                    onChange={(e) =>
                      handleOnChange(e, "select", "SelectedGemstoneValue")
                    }
                  >
                    <Option value="All">All</Option>
                    <Option value="Mined">Mined Gemstone</Option>
                  </Select>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-12 col-md-6">
            <div className="input__block">
              <label>
                <Spin spinning={showLoader} size="small">
                  <b>
                    {t("Total Clicks")} :{" "}
                    {TotalGemstoneClicks ? TotalGemstoneClicks : 0}
                  </b>
                </Spin>
              </label>
            </div>
          </div>
          {!showChart ? (
            <Spin spinning={showLoader}>
              <div className="col-lg-12">
                <div className="chart__section" id="pdf-content-price-wishlist">
                  {priceRange !== null &&
                    priceRange.length !== 0 &&
                    topPriceTotal.length !== 0 &&
                    JewelryPriceTableList &&
                    JewelryPriceTableList.length > 0 && (
                      <Pie
                        key={key}
                        onClick={(event) => {
                          const element = getElementAtEvent(
                            JewelPriceChartRef.current,
                            event
                          );
                          if (!element.length) return;

                          const { index } = element[0];

                          const price1 =
                            priceRange[index] == "Call for Price"
                              ? ""
                              : priceRange[index].includes("Under")
                              ? "0"
                              : priceRange[index].split("-")[0].split("$")[1];
                          const price2 =
                            priceRange[index] == "Call for Price"
                              ? ""
                              : priceRange[index].includes("Under")
                              ? priceRange[index].split("$")[1]
                              : priceRange[index].split("-").length > 1
                              ? priceRange[index].split("-")[1].split("$")[1]
                              : priceRange[index];
                          setSelectedData((prevState) => ({
                            ...prevState,
                            price:
                              priceRange[index] == "Call for Price"
                                ? "Call for Price"
                                : "",
                            price1: price1,
                            price2: price2,
                          }));
                        }}
                        ref={JewelPriceChartRef}
                        data={{
                          labels: priceRange,
                          datasets: [
                            {
                              data: topPriceTotal,
                              backgroundColor: [
                                "rgb(14, 220, 232)",
                                "rgb(16, 150, 24)",
                                "rgb(255, 153, 0)",
                                "rgb(153, 0, 153)",
                                "rgb(0, 153, 198)",
                                "rgb(51, 102, 204)",
                                "rgb(220, 57, 18)",
                                "rgb(102, 170, 0)",
                                "rgb(221, 68, 119)",
                                "rgb(237, 237, 1)",
                              ],
                              borderColor: [
                                "rgb(14, 220, 232)",
                                "rgb(16, 150, 24)",
                                "rgb(255, 153, 0)",
                                "rgb(153, 0, 153)",
                                "rgb(0, 153, 198)",
                                "rgb(51, 102, 204)",
                                "rgb(220, 57, 18)",
                                "rgb(102, 170, 0)",
                                "rgb(221, 68, 119)",
                                "rgb(237, 237, 1)",
                              ],
                              borderWidth: 1,
                            },
                          ],
                        }}
                        width={300}
                        height={300}
                        options={{
                          maintainAspectRatio: false,
                          responsive: true,
                          plugins: {
                            datalabels: {
                              display: true,
                              align: "end",
                              color: "rgb(255, 255, 255)",
                              font: {
                                size: 12,
                              },
                              formatter: (value) => {
                                if (totalValueForPercentage) {
                                  let finalPercentage = (
                                    (value / totalValueForPercentage) *
                                    100
                                  ).toFixed(2);
                                  setTooltipPercentage(finalPercentage);
                                  if (finalPercentage >= 5) {
                                    return finalPercentage + "%";
                                  } else {
                                    return "";
                                  }
                                }
                              },
                            },
                            tooltip: {
                              enabled: true,
                              callbacks: {
                                label: function (context) {
                                  let label = context.label || "";
                                  let formattedValue =
                                    context.formattedValue || "";

                                  if (label) {
                                    label =
                                      label +
                                      " " +
                                      formattedValue +
                                      " (" +
                                      TooltipPercentage +
                                      "%" +
                                      ")";
                                  }
                                  return label;
                                },
                              },
                            },
                            legend: {
                              position: "left",
                            },
                          },
                        }}
                      />
                    )}
                </div>
              </div>
            </Spin>
          ) : (
            <Spin spinning={showLoader}>
              <div className="no-report-render" id="pdf-content-price-wishlist">
                <div className="desc-space">
                  <h4 className="text-center">{t("No Data Found")}</h4>
                </div>
              </div>
            </Spin>
          )}
          <div className="col-lg-12 col-md-12 mt-4">
            <div className="table__scroll">
              <Table
                className="pendjewelreq__tbl"
                scroll={{ x: 1200, y: "calc(100vh - 340px)" }}
                columns={[
                  {
                    title: (
                      <Tooltip title={t("UserIPAddress")}>
                        {t("UserIPAddress")}
                      </Tooltip>
                    ),
                    ellipsis: true,
                    dataIndex: "usersIPAddress",
                    sorter: (a, b) => {},
                  },
                  {
                    title: <Tooltip title={t("Date")}>{t("Date")}</Tooltip>,
                    ellipsis: true,
                    dataIndex: "date",
                    sorter: (a, b) => {},
                    render: (item, row) => {
                      return moment(row.date).format("MM-DD-YYYY, hh:mm:ss A");
                    },
                  },
                  {
                    title: <Tooltip title={t("Shape")}>{t("Shape")}</Tooltip>,
                    ellipsis: true,
                    dataIndex: "shape",
                    sorter: (a, b) => {},
                  },
                  {
                    title: <Tooltip title={t("Size")}>{t("Size")}</Tooltip>,
                    ellipsis: true,
                    dataIndex: "size",
                    sorter: (a, b) => {},
                  },
                  {
                    title: <Tooltip title={t("Color")}>{t("Color")}</Tooltip>,
                    ellipsis: true,
                    dataIndex: "color",
                    sorter: (a, b) => {},
                  },
                  {
                    title: <Tooltip title={t("Gem Type")}>{t("Gem Type")}</Tooltip>,
                    ellipsis: true,
                    dataIndex: "gemTypeName",
                    sorter: (a, b) => {},
                  },

                  {
                    title: (
                      <Tooltip title={t("Clarity")}>{t("Clarity")}</Tooltip>
                    ),
                    ellipsis: true,
                    dataIndex: "clarity",
                    sorter: (a, b) => {},
                  },
                  {
                    title: (
                      <Tooltip title={t("Certificate")}>
                        {t("Certificate")}
                      </Tooltip>
                    ),
                    ellipsis: true,
                    dataIndex: "certificate",
                    sorter: (a, b) => {},
                  },
                  {
                    title: (
                      <Tooltip title={t("Retail Price")}>
                        {t("Retail Price")}
                      </Tooltip>
                    ),
                    ellipsis: true,
                    dataIndex: "retailPrice",
                    sorter: (a, b) => {},
                    render: (retailPrice) => (
                      <Tooltip title={retailPrice}>
                        <span>{retailPrice}</span>
                      </Tooltip>
                    ),
                  },
                  {
                    title: <Tooltip title={t("Cost")}>{t("Cost")}</Tooltip>,
                    ellipsis: true,
                    dataIndex: "cost",
                    sorter: (a, b) => {},
                    render: (cost) => (
                      <Tooltip title={cost}>
                        <span>{cost}</span>
                      </Tooltip>
                    ),
                  },
                ]}
                pagination={{
                  size: "small",
                  total: totalCount,
                  pageSizeOptions: [10, 15, 20, 50, 100],
                  responsive: true,
                  showSizeChanger: true,
                  pageSize: pageSize,
                  current: pageNo,
                }}
                onChange={handleTableASCDES}
                loading={showTableLoader}
                dataSource={JewelryPriceTableList}
              />
            </div>
          </div>
          <Modal
            title=""
            centered
            visible={visible}
            onOk={() => setVisible(false)}
            onCancel={() => setVisible(false)}
            width={500}
            footer={false}
          >
            <div className="">
              <img alt="img" className="img-fluid" />
            </div>
          </Modal>

          <Modal
            title=""
            centered
            visible={defaultVisible}
            onOk={() => setDefaultVisible(false)}
            onCancel={() => setDefaultVisible(false)}
            width={500}
            footer={false}
          >
            <div className="">
              <img src={DefaultImage} alt="img" className="img-fluid" />
            </div>
          </Modal>
        </div>
      </div>
    </React.Fragment>
  );
};

export default GemstonePriceBasedWishListReports;
